import Vue from 'vue'
import request from '@/helpers/request'
import EmployerFactory from '@/factory/employer'

export default {
  GET_CANDIDATES: ({ commit, state }, payload) => {
    const reset = payload.reset

    if (payload.showPreloader) {
      commit('setLoad', true)
    }

    if (reset) {
      commit('setCandidates', [])
    }
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.candidates.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result === 'success') {
        commit('setCandidates', state.candidates.concat(data.data))
        if (payload.showPreloader) {
          commit('setLoad', false)
        }
      } else {
        // TODO: Show error dialog
      }
    })
  },

  GET_CANDIDATE({ commit, state }, candidateID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.candidates.one.replace('$1', candidateID)}`,
      {},
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const candidate = _.first(response.data.data)
        commit('setCandidate', candidate)
        commit('setEmployer', new EmployerFactory().createWithCandidateObj(candidate))
        commit('setLoad', false)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_CANDIDATES_RULES: ({ commit, state }) => {
    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.vkstream.all}`, {}, true).then(response => {
      const data = response.data
      if (data.result === 'success') {
        commit('setCandidatesRulesArray', data.data)
      } else {
        // TODO: Show error dialog
      }
    })
  },

  ADD_CANDIDATES_RULE: ({ commit, state }, payload) => {
    request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.vkstream.all}`, payload, true).then(response => {
      const data = response.data
      if (data.result === 'success') {
        commit('setCandidatesRule', data.data)
        Vue.notify({
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.autoSelectSaveRuleMessage,
        })
      } else {
        // TODO: Show error dialog
        Vue.notify({
          title: '',
          type: 'error',
          text: Vue.config.localization.ru.autoSelectSaveRuleMessageError,
        })
      }
    })
  },
  // UPDATE_CANDIDATES_RULE: ({commit, state}, payload) => {
  //   request(
  //     'PUT',
  //     Vue.config.server + '/' + Vue.config.modules.crm.api.vkstream.one.replace('$1', payload.ruleID),
  //     payload.params,
  //     true
  //   )
  //     .then((response) => {
  //       const data = response.data;
  //       if (data.result === 'success') {
  //         commit('setCandidatesRulesArray', data);
  //       } else {
  //         // TODO: Show error dialog
  //       }
  //     });
  // },
  // UPDATE_CANDIDATES_RULE: ({commit, state}, payload) => {
  //   request(
  //     'PUT',
  //     Vue.config.server + '/' + Vue.config.modules.crm.api.vkstream.one.replace('$1', payload.ruleID),
  //     payload.params,
  //     true
  //   )
  //     .then((response) => {
  //       const data = response.data;
  //       if (data.result === 'success') {
  //         commit('setCandidatesRulesArray', data);
  //       } else {
  //         // TODO: Show error dialog
  //       }
  //     });
  // },
  DELETE_CANDIDATES_RULE: ({ commit, state }, payload) => {
    request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.vkstream.one.replace('$1', payload.id)}`,
      {},
      true,
    ).then(response => {
      const data = response.data
      if (data.result === 'success') {
        commit('deleteCandidatesRule', payload)
        Vue.notify({
          title: '',
          type: 'success',
          text: Vue.config.localization.ru.autoSelectDeleteRuleMessage,
        })
      } else {
        Vue.notify({
          title: '',
          type: 'error',
          text: Vue.config.localization.ru.autoSelectDeleteRuleMessageError,
        })
      }
    })
  },
}
